/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Badge_Title1Inputs */

const vi_sitesettings_brand_badge_title1 = /** @type {(inputs: Sitesettings_Brand_Badge_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chú thích khi rê chuột`)
};

/**

* @param {Sitesettings_Brand_Badge_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_badge_title1 = /** @type {((inputs?: Sitesettings_Brand_Badge_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Badge_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_badge_title1(inputs)
});
export { sitesettings_brand_badge_title1 as "siteSettings_brand_badge_title" }